import React from 'react';
import DrawerLeft from 'components/Common/Drawer';
import { Outlet } from 'react-router-dom';

export default function Layout() {
    return (
        <DrawerLeft>
            <Outlet />
        </DrawerLeft>
    );
}
